export default "__VITE_ASSET__CMiLSQqi__"